import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, from, AsyncSubject, forkJoin } from 'rxjs';
import { LoginService } from '../http/login.service';
import { UserInfoService } from '../http/user-info.service';
import { ClaimsAppSettings } from '../../../ViewModules/Claims/claims-configs'
import { MultiLingualService } from '../services'
import { AppMetadataHandler } from '../../configs'
import { NzMessageService } from 'ng-zorro-antd/message'
import { ThreadsService } from '../utilities/threads.service'
import { environment } from 'environments/environment';
import { ApiRequestService, CommonUtilty } from 'app';
import config from '../../../../configs/health-nbu-transaction.json'

export interface Credentials {
  // Customize received credentials here
  username: string;
  token: string;
  type?: string;
}

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

const credentialsKey = 'credentials';

/**
 * Provides a base for authentication workflow.
 * The Credentials interface as well as login/logout methods should be replaced with proper implementation.
 */
@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  private _credentials: Credentials | null;
  private _errorMsg
  public loadingFromToken


  constructor(
    private msg: NzMessageService,
    private appSettings?: ClaimsAppSettings,
    private userInfoService?: UserInfoService,
    private router?: Router,
    public loginService?: LoginService,
    private multiLingualService?: MultiLingualService,
    private appMetadataHandler?: AppMetadataHandler,
    private threadService?: ThreadsService,
    private apiRequestService?: ApiRequestService,
    private commonUtilty?: CommonUtilty
  ) {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Authenticates the user.
   * @param {LoginContext} context The login parameters.
   * @return {Observable<Credentials>} The user credentials.
   */
  login(context: LoginContext): Observable<Credentials> {
    // Replace by proper authentication call
    const data = {
      username: context.username,
      token: '123456',
      type: null
    };
    this.setCredentials(data, context.remember);
    return of(data);
  }

  checkPrivileges() {

  }

  fetchToken(context: LoginContext, landingRoute) {
    var messageId = this.msg.loading('Authenticating').messageId;

    this.loginService.getToken(context.username, context.password)
      .subscribe(resp => {



        let user = null;
        console.log("resp:" + JSON.stringify(resp));
        //Authentication
        if (resp.success == true) {

          //Authorization
          landingRoute = this._loginSuccessHandler(resp, context, landingRoute, messageId);
        }

        else if (resp.success == false) {
          /* Wrong username or Password */
          console.log('Authentication Failed');
          if (!environment.production)
            console.error('Check Allowed Roles in AppMetaDataHandler')
          this.msg.error("Authentication Failed");
          this.loadingFromToken = false

        }
      },
        errResponse => {
          console.log("errResponse:" + JSON.stringify(errResponse));
          switch (errResponse.status) {
            case 401:
              this._errorMsg = 'Username or password is incorrect';
              break;
            case 404:
              this._errorMsg = 'Service not found';
            case 408:
              this._errorMsg = 'Request Timedout';
            case 500:
              this._errorMsg = 'Internal Server Error';
            default:
              this._errorMsg = 'Server Error';
          }
        }
      );




  }
  _startThreadLog(msg) {
    console.log(`%c${msg}`, 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
  }
  _successThreadLog(msg) {
    console.log(`%c${msg}`, 'color: white; background-color: green; padding: 2px 5px; border-radius: 2px');
  }

  _errorThreadLog(msg) {
    console.log(`%c${msg}`, 'color: white; background-color: red; padding: 2px 5px; border-radius: 2px');
  }

  FETCHCONFIGJSON() {
    let msg = 'FETCH CONFIG Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    // this.apiRequestService.get(environment['configPath'], null, true).subscribe(res => {
    //   if (res) {
    //     this.appMetadataHandler.configDataJSON = this.commonUtilty.deepCopy(res);
        this.appMetadataHandler.configDataJSON = config;
        this._successThreadLog('FETCH CONFIG Thread Completed');
        caller.next({ status: true });
        caller.complete();
    //   }
    //   else {
    //     this._errorThreadLog('There is some problem in FETCH CONFIG Thread. Invalid Response from Server. Cannot move ahead without this');
    //   }
    // })
    return caller;
  }

  MapperThread() {
    let msg = 'Mapper Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    let threadList: Array<any> = []
    threadList.push(this.APIENDPOINTMAPPERSTRATEGY())
    forkJoin(threadList).subscribe(res => {
      caller.next({ status: res });
      caller.complete();
    })

    return caller;
  }
  APIENDPOINTMAPPERSTRATEGY() {
    let msg = 'API MASTER LOAD Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    this.apiRequestService.getAPIMaster().subscribe(res => {
      if (res) {
        this._successThreadLog('API MASTER LOAD Thread Completed');
        caller.next({ status: true });
        caller.complete();
      }
      else {
        this._errorThreadLog('There is some problem in API MASTER LOAD Thread. Invalid Response from Server. Cannot move ahead without this');
      }
    })
    return caller;
  }

  public _loginSuccessHandler(resp: any, context?: LoginContext, landingRoute?: any, messageId?: string) {
    // if (resp?.user?.oneTimePasswordFl === true) {
    //   landingRoute = '/resetPassword';
    // }
    // this.router.navigate([landingRoute]);
    if (this.currentRolePrivilege(this.appSettings._allowedRoles, resp.user.typeCd)) {
      const data = {
        username: resp.user.userId,
        token: resp.user.token,
        type: resp.user.typeCd
      };
      let loginResp = resp
      this.setCredentials(data, context.remember);
      this.FETCHCONFIGJSON().subscribe(resp => {
        if (resp['status']) {
          this.threadService._successThreadLog('Post login thread completed');
          this.MapperThread().subscribe(resp => {
            if (resp['status']) {
              this.multiLingualService.init();
              if (!this.appMetadataHandler.featureFlags.waitForLabelsAfterLogin) {
                landingRoute = this.extractEntryPointAndNavigateToLanding(loginResp, landingRoute);
              }
              else {
                this.multiLingualService.currentLanguageLoaded.subscribe(lang => {
                  if (lang === this.appMetadataHandler.defaultLanguage) {
                    if (messageId)
                      this.msg.remove(messageId);
                    landingRoute = this.extractEntryPointAndNavigateToLanding(loginResp, landingRoute);
                  }
                });
              }
              this.threadService._successThreadLog('Post login thread completed');
              this.threadService.POSTLOGINTHREAD().subscribe(resp => {
                if (resp['status']) {
                  this.threadService._successThreadLog('Post login thread completed');
                }
                else
                  this.threadService._errorThreadLog('There is some problem in post login thread');
              });
            }
            else
              this.threadService._errorThreadLog('There is some problem in post login thread');
          })
        }
        else
          this.threadService._errorThreadLog('There is some problem in post login thread');
      });
      // this.multiLingualService.init();
      // this.threadService.POSTLOGINTHREAD().subscribe(resp => {
      //   if (resp['status'])
      //   {
      //     this.threadService._successThreadLog('Post login thread completed');
      //     this.MapperThread().subscribe(resp => {
      //       if (resp['status']) {
      //         this.multiLingualService.init();
      //         if (!this.appMetadataHandler.featureFlags.waitForLabelsAfterLogin) {
      //           landingRoute = this.extractEntryPointAndNavigateToLanding(loginResp, landingRoute);
      //         }
      //         else {
      //           this.multiLingualService.currentLanguageLoaded.subscribe(lang => {
      //             if (lang === this.appMetadataHandler.defaultLanguage) {
      //               if (messageId)
      //                 this.msg.remove(messageId);
      //               landingRoute = this.extractEntryPointAndNavigateToLanding(loginResp, landingRoute);
      //             }
      //           });
      //         }
      //         this.threadService._successThreadLog('Post login thread completed');
      //         this.threadService.POSTLOGINTHREAD().subscribe(resp => {
      //           if (resp['status']) {
      //             this.threadService._successThreadLog('Post login thread completed');
      //           }
      //           else
      //             this.threadService._errorThreadLog('There is some problem in post login thread');
      //         });
      //       }
      //       else
      //         this.threadService._errorThreadLog('There is some problem in post login thread');
      //     })
      //   }
      //   else
      //     this.threadService._errorThreadLog('There is some problem in post login thread');
      // });
      // // this.router.navigate([landingRoute]);
      // this.multiLingualService.currentLanguageLoaded.subscribe(lang => {
      //   if (lang === this.appMetadataHandler.defaultLanguage) {
      //     if (messageId)
      //       this.msg.remove(messageId);
      //     resp.user.userRoleDOList.forEach(userRole => {
      //       let foundRoleSpecificLanding = this.appMetadataHandler.getEntryPoint(userRole.roleId);
      //       if (foundRoleSpecificLanding && resp?.user?.oneTimePasswordFl === false)
      //         landingRoute = foundRoleSpecificLanding;
      //     });
      //     this.router.navigate([landingRoute]);
      //   }
      // });
    }
    else {
      this.loadingFromToken = false
      console.log('Authorization Error');
      this.msg.error("Authorization Error");
    }
    return landingRoute;
  }

  private extractEntryPointAndNavigateToLanding(resp: any, landingRoute: any) {
    resp.user.userRoleDOList.forEach(userRole => {
      let foundRoleSpecificLanding = this.appMetadataHandler.getEntryPoint(userRole.roleId);
      if (foundRoleSpecificLanding)
        landingRoute = foundRoleSpecificLanding;
    });
    this.router.navigate([landingRoute]);
    return landingRoute;
  }

  public _bypassLoginSuccessHandler(context?: LoginContext, landingRoute?: any, messageId?: string) {
    if (true) {
      const data = {
        username: "test user",
        token: "test 1234",
        type: "test"
      };
      this.setCredentials(data, context.remember);
      // this.multiLingualService.init();
      this.threadService.POSTLOGINTHREAD().subscribe(resp => {
        if (resp['status'])
          this.threadService._successThreadLog('Post login thread completed');
        else
          this.threadService._errorThreadLog('There is some problem in post login thread');
      });
      this.router.navigate([landingRoute]);
      // this.multiLingualService.currentLanguageLoaded.subscribe(lang => {
      //   if (lang === this.appMetadataHandler.defaultLanguage) {
      //     if (messageId)
      //       this.msg.remove(messageId);
      //     resp.user.userRoleDOList.forEach(userRole => {
      //       let foundRoleSpecificLanding = this.appMetadataHandler.getEntryPoint(userRole.roleId);
      //       if (foundRoleSpecificLanding)
      //         landingRoute = foundRoleSpecificLanding;
      //     });
      //     this.router.navigate([landingRoute]);
      //   }
      // });
    }
    else {
      this.loadingFromToken = false
      console.log('Authorization Error');
      this.msg.error("Authorization Error");
    }
    return landingRoute;
  }

  /**
   * Logs out the user and clear credentials.
   * @return {Observable<boolean>} True if the user was logged out successfully.
   */
  logout(): Observable<boolean> {
    // Customize credentials invalidation here
    this.setCredentials();
    return of(true);
  }

  /**
   * Checks is the user is authenticated.
   * @return {boolean} True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Checks is the user is authenticated.
   * @return {string} if the user is authenticated returns back type of user.
   */
  getUserType(): string {
    return this._credentials.type;
  }

  /**
   * Checks is the user is authenticated.
   * @return {boolean} if the user has privileges to access the module.
   */
  checkUserPrivilege(allowedRoles: Array<any>): boolean {

    var matchedRoles = allowedRoles.filter(role => {
      let userType = this.getUserType()
      return userType === role
    })

    return matchedRoles.length > 0
  }

  currentRolePrivilege(allowedRoles: Array<any>, currentRole: string): boolean {
    var matchedRoles = allowedRoles.filter(role => {
      let userType = currentRole
      return userType === role
    })

    return matchedRoles.length > 0
  }

  /**
   * Gets the user credentials.
   * @return {Credentials} The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    return this._credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param {Credentials=} credentials The user credentials.
   * @param {boolean=} remember True to remember credentials across sessions.
   */
  private setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }

}
